import type { RootState } from '@/app/store';

export const selectProductionOrderByIdData = (state: RootState) =>
  state.productionOrder.productionOrderData;
export const selectProductionOrderByIdLoading = (state: RootState) =>
  state.productionOrder.loading;
export const selectProductionOrderByIdError = (state: RootState) =>
  state.productionOrder.error;
